/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sortingdesc1Inputs */

const en__field_sortingdesc1 = /** @type {(inputs: _Field_Sortingdesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descending`)
};

const de__field_sortingdesc1 = /** @type {(inputs: _Field_Sortingdesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absteigend`)
};

/**
* | output |
* | --- |
* | "Descending" |
*
* @param {_Field_Sortingdesc1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sortingdesc1 = /** @type {((inputs?: _Field_Sortingdesc1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sortingdesc1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sortingdesc1(inputs)
	return de__field_sortingdesc1(inputs)
});
export { _field_sortingdesc1 as "_field_sortingDesc" }